<template>
  <div>
  <PopDialog2
    title="방 정보 수정"
    :visible="props.visible"
    :cancelCallback="onCancelClick"
    compact
  >
    <div class="md-layout">
      <div class="md-layout-item md-size-50 mx-auto text-center mb-4">

        <h2 :class="`title mt-4 ml-${isOwnerZone ? 4 : 0}`">
          {{ lampDisplayName }}
          <button class="btn dropdown-toggle" type="button" id="menus" data-bs-toggle="dropdown" aria-expanded="true" ref="menusButton" v-if="isOwnerZone" />
          <ul class="dropdown-menu" aria-labelledby="menus" v-if="isOwnerZone">
            <li class="dropdown-item" @click="onChangeNameClick">이름 변경</li>
            <li class="dropdown-item" @click="onDeleteClick">삭제</li>
          </ul>
        </h2>
        <button
          type="button"
          class="light-device-power-btn mb-4"
          :class="getPower ? 'light-device-power-btn--on' : 'light-device-power-btn--off'"
          :style="getPower ? powerBtnOnStyle : undefined"
          @click="props.handlePowerClick"
        >
          <i class="fa-solid fa-power-off"></i>
        </button>

        <div class="light-device-sliders px-2" v-if="!device.isVirtual">
          <ListGroupItem class="light-device-slider-row light-device-slider-row--bright">
            <Slider
              name="밝기"
              id="color-bright-device"
              layout="stacked"
              thin
              filled-track
              track-variant="bright"
              :min="10"
              :max="100"
              :step="10"
              :default="lightBright"
              :disabled="!getPower"
              value-suffix="%"
              v-on:onSliderChanged="onBrightChanged"
            />
          </ListGroupItem>
          <ListGroupItem class="light-device-slider-row light-device-slider-row--temp">
            <Slider
              name="색온도"
              id="color-temp-device"
              layout="stacked"
              thin
              filled-track
              track-variant="temp"
              :min="0"
              :max="20"
              :step="2"
              :default="lightColor"
              :disabled="!getPower"
              v-on:onSliderChanged="onColorChanged"
            />
          </ListGroupItem>
        </div>

        <div style="margin-left: 20px;margin-right: 20px; margin-top: 10px;" v-else>
          <ListGroupItem
            style="padding-top: 0.3rem; padding-bottom: 0.3rem;"
          >
            <div class="d-flex gap-2 w-100">
              <button
                type="button"
                class="btn btn-primary flex-fill"
                @click="onUpdateVirtualClick"
              >
                가상버튼 수정
              </button>
              <button
                type="button"
                class="btn btn-outline-primary flex-fill"
                @click="isBoundButtonAssigned ? onBoundButtonClearClick() : onBoundButtonAssignClick()"
              >
                {{ isBoundButtonAssigned ? '물리 버튼 해제' : '물리 버튼 할당' }}
              </button>
            </div>
          </ListGroupItem>
          <ListGroupItem
            v-if="isBoundButtonAssigned"
            style="padding-top: 0.2rem; padding-bottom: 0.2rem;"
          >
            <div
              class="virtual-switch-info-root w-100"
              :class="{ 'is-expanded': isBoundButtonInfoExpanded }"
            >
              <div
                class="virtual-switch-info-header"
                role="button"
                tabindex="0"
                @click="toggleBoundButtonInfo"
                @keyup.enter="toggleBoundButtonInfo"
                @keyup.space.prevent="toggleBoundButtonInfo"
              >
                <div class="virtual-switch-info-title">
                  <span>할당된 물리 버튼</span>
                </div>
                <div class="virtual-switch-info-chevron" aria-hidden="true">
                  <i :class="`fa ${isBoundButtonInfoExpanded ? 'fa-chevron-up' : 'fa-chevron-down'}`" style="font-size: 0.75rem;"></i>
                </div>
              </div>
              <transition name="virtual-switch-expand">
                <div v-show="isBoundButtonInfoExpanded" class="virtual-switch-info-body">
                  <div class="virtual-switch-detail-row">
                    <span class="virtual-switch-detail-label">
                      <i class="fa-solid fa-hashtag" aria-hidden="true"></i>
                      시리얼
                    </span>
                    <span class="virtual-switch-detail-value">{{ boundButtonSerialWithName }}</span>
                  </div>
                  <div class="virtual-switch-detail-row">
                    <span class="virtual-switch-detail-label">
                      <i class="fa-solid fa-plug" aria-hidden="true"></i>
                      버튼 포트
                    </span>
                    <span class="virtual-switch-detail-value">{{ toDisplayLampPort(device.boundButton.port, device.boundButton.controllerId) }}</span>
                  </div>
                  <div class="virtual-switch-detail-row" v-if="boundButtonDisplayName">
                    <span class="virtual-switch-detail-label">
                      <i class="fa-solid fa-tag" aria-hidden="true"></i>
                      버튼 이름
                    </span>
                    <span class="virtual-switch-detail-value">{{ boundButtonDisplayName }}</span>
                  </div>
                </div>
              </transition>
            </div>
          </ListGroupItem>
          <ListGroupItem 
            v-if="hasVirtualSwitchController"
            style="padding-top: 0.3rem; padding-bottom: 0.3rem;"
          >
            <button
              type="button"
              class="btn btn-outline-primary flex-fill"
              @click="onVirtualSwitchConnectClick"
            >
              {{ isVirtualSwitchReconnect ? '가상스위치 재연결' : '가상스위치 연결' }}
            </button>
          </ListGroupItem>
          <ListGroupItem
            v-if="hasVirtualSwitchController && isVirtualSwitchReconnect"
            style="padding-top: 0.2rem; padding-bottom: 0.2rem;"
          >
            <div
              class="virtual-switch-info-root w-100"
              :class="{ 'is-expanded': isVirtualSwitchInfoExpanded }"
            >
              <div
                class="virtual-switch-info-header"
                role="button"
                tabindex="0"
                @click="toggleVirtualSwitchInfo"
                @keyup.enter="toggleVirtualSwitchInfo"
                @keyup.space.prevent="toggleVirtualSwitchInfo"
              >
                <div class="virtual-switch-info-title">
                  <i class="fa-solid fa-microchip virtual-switch-info-icon" aria-hidden="true"></i>
                  <span>연결된 가상스위치 정보</span>
                </div>
                <div class="virtual-switch-info-chevron" aria-hidden="true">
                  <i :class="`fa ${isVirtualSwitchInfoExpanded ? 'fa-chevron-up' : 'fa-chevron-down'}`" style="font-size: 0.75rem;"></i>
                </div>
              </div>
              <transition name="virtual-switch-expand">
                <div v-show="isVirtualSwitchInfoExpanded" class="virtual-switch-info-body">
                  <div class="virtual-switch-detail-row">
                    <span class="virtual-switch-detail-label">
                      <i class="fa-solid fa-hashtag" aria-hidden="true"></i>
                      시리얼
                    </span>
                    <span class="virtual-switch-detail-value">{{ device.virtualMap.serial }}</span>
                  </div>
                  <div class="virtual-switch-detail-row">
                    <span class="virtual-switch-detail-label">
                      <i class="fa-solid fa-plug" aria-hidden="true"></i>
                      포트
                    </span>
                    <span class="virtual-switch-detail-value">{{ device.virtualMap.port }}</span>
                  </div>
                </div>
              </transition>
            </div>
          </ListGroupItem>
        </div>
      </div>
    </div>
  </PopDialog2>
  <DeviceItemModal
    v-if="deviceItemModal.visible"
    :visible="deviceItemModal.visible"
    :okCallback="onUpdateDeviceName"
    :cancelCallback="deviceItemModal.hide"
    :deviceName="device.name || ''"
    :groupId="props.roomId"
  />
</div>
</template>

<script setup>
import { ref, defineProps, computed, getCurrentInstance, reactive, watch, nextTick, onBeforeUnmount } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { DeviceType, PowerState, ButtonConfig, lightButtonColors } from '@/common/constants';
import {
  hasPhysicalMappingMembers,
  isPhysicalMappingHostDevice,
  onPhysicalMappingHostControl,
  preparePhysicalMappingMemberDirectControl,
} from '@/common/utils/physicalMappingMember';
import { buildButtonMapsForController, publishButtonMapsPayload } from '@/common/utils/buttonMaps';
import { resolveBoundButtonDisplayName } from '@/common/utils/boundButtonLabel';
import { formatControllerSerialWithName, toDisplayLampPort } from '@/common/utils/controllerDisplayName';
import useMqttControl from '@/common/hooks/useMqttControl';
import useModal from '@/common/hooks/useModal';
import PopDialog2 from '@/common/components/popup/PopDialog2.vue';
import Slider from '@/common/components/widgets/Slider.vue';
import ListGroupItem from '@/common/components/widgets/ListGroupItem.vue';
import DeviceItemModal from './DeviceItemModal.vue';
import Axios, { DeviceApi } from '@/api';

const router = useRouter();
const mqttControl = reactive(useMqttControl());
const { emitter } = getCurrentInstance().appContext.config.globalProperties;
const store = useStore();
const props = defineProps([
  'visible',
  'cancelCallback',
  'roomName',
  'roomId',
  'deviceId',
  'handlePowerClick'
]);
const deviceItemModal = reactive(useModal());
const menusButton = ref(null);
const timerId = ref(null);
const isVirtualSwitchInfoExpanded = ref(false);
const isBoundButtonInfoExpanded = ref(false);
const boundButtonAssignTimerId = ref(null);
const boundButtonAssignCountdownId = ref(null);
const boundButtonAssignRemainSec = ref(0);

const BOUND_BUTTON_ASSIGN_TIMEOUT_MS = 30000;

const boundButtonAssignWaitDescription = (sec) =>
  `할당할 물리(벽면) 버튼을 길게 눌러주세요\n남은 시간 ${sec}초`;

const clearBoundButtonAssignTimers = () => {
  if (boundButtonAssignTimerId.value) {
    clearTimeout(boundButtonAssignTimerId.value);
    boundButtonAssignTimerId.value = null;
  }
  if (boundButtonAssignCountdownId.value) {
    clearInterval(boundButtonAssignCountdownId.value);
    boundButtonAssignCountdownId.value = null;
  }
};

const toggleVirtualSwitchInfo = () => {
  isVirtualSwitchInfoExpanded.value = !isVirtualSwitchInfoExpanded.value;
};

const toggleBoundButtonInfo = () => {
  isBoundButtonInfoExpanded.value = !isBoundButtonInfoExpanded.value;
};

const zone = computed(() => {
  if (store.state.home.zones.length > 0) {
    return store.getters['home/getCurrentZone'];
  } else return null;
});
const isOwnerZone = computed(() => {
  return zone.value?.ownerId != undefined
    && store.getters['account']?._id != undefined
    && zone.value?.ownerId === store.getters['account']?._id;
});
const group = computed(() => {
  return zone.value.groups.find((g) => g._id === props.roomId);
});
const devices = computed(() => {
  return group.value ? group.value.devices : undefined;
});
const device = computed(() => {
  return devices.value.find(
    (d) => d._id === props.deviceId,
  );
});
const isMappingButton = ref(false);
const lampDisplayName = computed(() => {
  const name = device.value?.name || '';
  if (device.value?.isVirtual) return name;
  return isMappingButton.value ? `${name}(매핑버튼)` : name;
});
watch(
  () => [props.visible, device.value?._id, device.value?.isVirtual],
  async ([visible]) => {
    if (!visible || device.value?.isVirtual || device.value?._id == null) {
      isMappingButton.value = false;
      return;
    }
    isMappingButton.value = await hasPhysicalMappingMembers(device.value._id);
  },
);

const hasVirtualSwitchController = computed(() => {
  const controllers = zone.value?.controllers;
  if (!controllers?.length) return false;
  return controllers.some((c) => {
    const model = c?.model;
    if (model != null && String(model).startsWith('M91')) return true;
    const id = c?._id;
    return id != null && String(id).split('_')[0] === 'M91';
  });
});

const isVirtualSwitchReconnect = computed(() => {
  const vm = device.value?.virtualMap;
  if (!vm || vm.serial == null || String(vm.serial).trim() === '') return false;
  if (vm.port === undefined || vm.port === null) return false;
  return true;
});

const isBoundButtonAssigned = computed(() => {
  const bb = device.value?.boundButton;
  if (!bb || bb.controllerId == null || String(bb.controllerId).trim() === '') return false;
  if (bb.port === undefined || bb.port === null) return false;
  return true;
});

const boundButtonDisplayName = computed(() =>
  resolveBoundButtonDisplayName(device.value, store.getters['home/getZones']),
);

/** 시리얼 + (제어기 이름) — 버튼 이름은 별도 행 */
const boundButtonSerialWithName = computed(() => {
  const serial = device.value?.boundButton?.controllerId;
  if (serial == null || String(serial).trim() === '') return '';
  const sid = String(serial);
  const zones = store.getters['home/getZones'] || [];
  for (const z of zones) {
    const found = (z.controllers || []).find((c) => String(c?._id) === sid);
    if (found) return formatControllerSerialWithName(found);
  }
  return sid;
});

const virtualSwtichSettingCount = computed(() => {
  return store.getters['home/getVirtualSwtichSettingCount'];
});

const boundButtonSettingCount = computed(() => {
  return store.getters['home/getBoundButtonSettingCount'];
});

watch(virtualSwtichSettingCount, () => {
  if (timerId.value) {
    clearTimeout(timerId.value);
    timerId.value = null;
    emitter.emit('hideLoading');
    emitter.emit('showPopAlert', {
      description: '가상스위치가 연결되었습니다.',
    });
  }
});

const isBoundButtonAssignWaiting = ref(false);

const stopBoundButtonAssignWait = ({ clearSettingDevice = true } = {}) => {
  clearBoundButtonAssignTimers();
  isBoundButtonAssignWaiting.value = false;
  if (clearSettingDevice) {
    store.commit('home/setBoundButtonSettingDevice', undefined);
  }
  emitter.emit('hideLoading');
};

const exitBoundButtonAssignPreview = async (serial, port) => {
  if (!serial) return;
  try {
    // bm 수신 시 펌웨어가 설정모드 종료 + 프리뷰 조명 소등
    await store.dispatch('fetchAllZones');
    let maps = await buildButtonMapsForController(
      serial,
      store.getters['home/getZones'],
    );
    // maps 가 비면 bm 미발행 → 설정모드 잔류. 해당 포트 1:1 로라도 발행
    if (!maps.length && Number.isInteger(Number(port))) {
      const p = Number(port);
      maps = [{ port: p, ports: [p] }];
    }
    publishButtonMapsPayload(mqttControl, serial, maps);
  } catch (e) {
    console.error('exit setting preview after boundButton assign failed:', e);
  }
};

watch(boundButtonSettingCount, async () => {
  if (!isBoundButtonAssignWaiting.value) return;

  stopBoundButtonAssignWait({ clearSettingDevice: false });

  const err = store.state.home.boundButtonLastError;
  // 할당은 반영됐는데 겹친 응답이 실패로 먼저 올라온 경우 성공으로 끝낸다
  if (err && !isBoundButtonAssigned.value) {
    store.commit('home/setBoundButtonLastError', undefined);
    const errObj = typeof err === 'object' && err != null
      ? err
      : {
          message: String(err),
          hint: '',
          serial: undefined,
        };
    const parts = [];
    if (errObj.message) parts.push({ text: errObj.message });
    if (errObj.hint) parts.push({ text: errObj.hint, danger: true });

    // 확인/닫기 시 설정 프리뷰 조명 소등 (bm → Exit Setting Mode)
    const onDismiss = async () => {
      await exitBoundButtonAssignPreview(errObj.serial, errObj.port);
    };
    // 대기 팝업을 닫지 않고 문구만 바꿔 빈 화면 깜박임을 막는다
    emitter.emit('showPopAlert', {
      title: '알림',
      descriptionParts: parts.length > 0 ? parts : undefined,
      description: parts.length === 0 ? String(err) : undefined,
      showCancel: false,
      showOk: true,
      okText: '확인',
      okCallback: onDismiss,
      closeCallback: onDismiss,
    });
    return;
  }

  if (err) {
    store.commit('home/setBoundButtonLastError', undefined);
  }

  const last = store.state.home.boundButtonLastAbsorb;
  store.commit('home/setBoundButtonLastAbsorb', undefined);
  const absorb = last?.absorb ?? (last?.absorbed ? last : null);
  const restore = last?.restore || null;

  const portLabel = device.value?.boundButton?.port != null
    ? toDisplayLampPort(device.value.boundButton.port, device.value.boundButton.controllerId)
    : null;
  const boundName = resolveBoundButtonDisplayName(
    device.value,
    store.getters['home/getZones'],
  );
  let description =
    boundName != null
      ? `물리버튼 ${boundName}에 할당되었습니다`
      : portLabel != null
        ? `물리버튼 ${portLabel}번에 할당되었습니다`
        : '물리버튼에 할당되었습니다';
  if (absorb?.absorbed) {
    const added = Number(absorb.addedCount) || 0;
    description +=
      added > 0
        ? `\n기존 조명·매핑 ${added}개를 가상버튼에 흡수했습니다.`
        : '\n기존 물리 버튼 등록을 해제하고 가상버튼에 연결했습니다.';
  }
  emitter.emit('showPopAlert', {
    title: '알림',
    description,
    showCancel: false,
    showOk: true,
    okText: '확인',
  });

  const pushBmForSerial = async (serial) => {
    if (!serial) return;
    try {
      await store.dispatch('fetchAllZones');
      const maps = await buildButtonMapsForController(
        serial,
        store.getters['home/getZones'],
      );
      publishButtonMapsPayload(mqttControl, serial, maps);
    } catch (e) {
      console.error('button maps push after boundButton failed:', e);
    }
  };

  // 흡수 여부와 관계없이 할당된 보드에 bm 을 보내 설정모드를 끝내고 씬을 반영한다
  const bmSerials = new Set();
  const boundSerial = device.value?.boundButton?.controllerId;
  if (boundSerial) bmSerials.add(String(boundSerial));
  if (absorb?.absorbed && absorb?.controllerId) bmSerials.add(String(absorb.controllerId));
  if (restore?.restored && restore?.controllerId) bmSerials.add(String(restore.controllerId));
  for (const serial of bmSerials) {
    await pushBmForSerial(serial);
  }
});

watch(() => props.visible, (v) => {
  if (!v) {
    isVirtualSwitchInfoExpanded.value = false;
    isBoundButtonInfoExpanded.value = false;
    // 물리버튼 할당 대기 중에는 설정 팝업을 닫아도 대기를 유지한다
  }
});

onBeforeUnmount(() => {
  if (isBoundButtonAssignWaiting.value || boundButtonAssignTimerId.value) {
    stopBoundButtonAssignWait();
    emitter.emit('hidePopAlert');
  }
});

const getPower = computed(() => {
  return device.value.item?.onoff === PowerState.On;
});

const lightBright = computed(() => {
  return device.value.item?.bright;
});

const lightColor = computed(() => {
  return device.value.item?.color;
});

const buttonColor = computed(() => {
  const index = device.value.item?.color / 2;
  return device.value.item?.color !== undefined && lightButtonColors.length > index ? lightButtonColors[index] : "#ffe082";
});

const hexToRgb = (hex) => {
  const raw = String(hex || '').replace('#', '');
  const full = raw.length === 3 ? raw.split('').map((c) => c + c).join('') : raw;
  const n = parseInt(full, 16);
  if (Number.isNaN(n)) {
    return { r: 255, g: 224, b: 130 };
  }
  return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
};

const mixTowardWhite = (hex, amount) => {
  const { r, g, b } = hexToRgb(hex);
  const mix = (c) => Math.round(c + (255 - c) * amount);
  return `rgb(${mix(r)}, ${mix(g)}, ${mix(b)})`;
};

/** 색온도 10 기준 회색 테두리: 0·20에서는 없음, 멀어질수록 연해짐 */
const POWER_BORDER_PEAK_COLOR = 10;
const POWER_BORDER_PEAK_ALPHA = 0.52;

const powerBorderOpacity = (colorTemp) => {
  const color = Number(colorTemp);
  if (Number.isNaN(color)) {
    return POWER_BORDER_PEAK_ALPHA;
  }
  const distance = Math.abs(color - POWER_BORDER_PEAK_COLOR);
  const ratio = 1 - distance / POWER_BORDER_PEAK_COLOR;
  return Math.max(0, POWER_BORDER_PEAK_ALPHA * ratio);
};

/** 켜짐: 색온도 색상 기반 radial glow, 테두리는 색온도 10 기준 단계적 회색 */
const powerBtnOnStyle = computed(() => {
  const base = buttonColor.value || '#ffe082';
  const { r, g, b } = hexToRgb(base);
  const borderAlpha = powerBorderOpacity(device.value?.item?.color);
  return {
    '--power-center': mixTowardWhite(base, 0.55),
    '--power-mid': mixTowardWhite(base, 0.28),
    '--power-edge': base,
    '--power-border': `rgba(168, 173, 180, ${borderAlpha})`,
    '--power-glow': `rgba(${r}, ${g}, ${b}, 0.45)`,
    '--power-ring': `rgba(${r}, ${g}, ${b}, 0.35)`,
    '--power-inset': 'rgba(255, 255, 255, 0.75)',
  };
});

// watch(lightBright, () => {
//   console.log(lightBright.value)
// })

const onCancelClick = () => {
  if (props.cancelCallback) {
    props.cancelCallback();
  }
};

const onBrightChanged = async (e) => {
  if (zone.value.isEditMode) {
    emitter.emit('showPopAlert', {
      description: '세팅중인 영역의 단말은 제어 할 수 없습니다.',
    });
    return;
  }

  emitter.emit('showLoading');
  try {
    const onoff = device.value?.onVirtual === true
      ? ((device.value.item?.state?.onoff ?? 0) === 1 ? 0 : 1)
      : device.value.item?.onoff;
    const bright = parseInt(e, 10);
    const color = device.value.item?.color ?? 0;

    mqttControl.onPublish(device.value.controllerId, device.value._id, {
      serial: device.value.controllerId,
      cmd: 'c',
      type: 1,
      data: {
        ports: device.value.item?.ports?.map((p) => p),
        onoff,
        bright,
        color,
      },
    });

    const isHost = await isPhysicalMappingHostDevice(device.value._id);
    if (isHost) {
      await onPhysicalMappingHostControl(store, device.value._id, onoff, bright, color);
    } else {
      preparePhysicalMappingMemberDirectControl(store, device.value._id, onoff, bright, color);
    }
    setTimeout(() => emitter.emit('hideLoading'), ButtonConfig.delay);
  } catch (err) {
    emitter.emit('hideLoading');
  }
};

const onColorChanged = async (e) => {
  if (zone.value.isEditMode) {
    emitter.emit('showPopAlert', {
      description: '세팅중인 영역의 단말은 제어 할 수 없습니다.',
    });
    return;
  }

  emitter.emit('showLoading');
  try {
    const onoff = device.value?.onVirtual === true
      ? ((device.value.item?.state?.onoff ?? 0) === 1 ? 0 : 1)
      : device.value.item?.onoff;
    const bright = device.value.item?.bright;
    const color = parseInt(e, 10);

    mqttControl.onPublish(device.value.controllerId, device.value._id, {
      serial: device.value.controllerId,
      cmd: 'c',
      type: 1,
      data: {
        ports: device.value.item?.ports?.map((p) => p),
        onoff,
        bright,
        color,
      },
    });

    const isHost = await isPhysicalMappingHostDevice(device.value._id);
    if (isHost) {
      await onPhysicalMappingHostControl(store, device.value._id, onoff, bright, color);
    } else {
      preparePhysicalMappingMemberDirectControl(store, device.value._id, onoff, bright, color);
    }
    setTimeout(() => emitter.emit('hideLoading'), ButtonConfig.delay);
  } catch (err) {
    emitter.emit('hideLoading');
  }
};

const onUpdateVirtualClick = () => {
  const hasVirtualOn = (devices.value || []).some((d) => d?.isVirtual === true && d?.item?.onoff == 1);
  if (hasVirtualOn) {
    emitter.emit('showPopAlert', {
      description: '가상 스위치가 켜져 있을 때는\n가상 스위치를 추가/수정할 수 없습니다.',
    });
    return;
  }
  router.push(`/virtual/${group.value._id}/${device.value._id}`);
}

const onVirtualSwitchConnectClick = () => {
  store.commit('home/setVirtualSwitchSettingDevice', device.value);

  emitter.emit('showLoading');
  timerId.value = setTimeout(() => {
    timerId.value = null;
    emitter.emit('hideLoading');
    emitter.emit('showPopAlert', {
      description: '가상스위치 연결에 실패했습니다.',
    });
  }, 10000);
}

const startBoundButtonAssignWait = () => {
  if (isBoundButtonAssigned.value) {
    emitter.emit('showPopAlert', {
      description: '이미 물리 버튼이 할당되어 있습니다.\n먼저 해제한 뒤 새로 할당해주세요.',
    });
    return;
  }
  store.commit('home/setBoundButtonLastError', undefined);
  store.commit('home/setBoundButtonLastAbsorb', undefined);
  store.commit('home/setBoundButtonSettingDevice', device.value);
  isBoundButtonAssignWaiting.value = true;

  clearBoundButtonAssignTimers();

  const totalSec = Math.ceil(BOUND_BUTTON_ASSIGN_TIMEOUT_MS / 1000);
  boundButtonAssignRemainSec.value = totalSec;

  boundButtonAssignTimerId.value = setTimeout(async () => {
    boundButtonAssignTimerId.value = null;
    if (!isBoundButtonAssignWaiting.value) return;
    clearBoundButtonAssignTimers();
    isBoundButtonAssignWaiting.value = false;
    store.commit('home/setBoundButtonSettingDevice', undefined);
    emitter.emit('hidePopAlert');
    await nextTick();
    emitter.emit('showPopAlert', {
      description: '물리 버튼 할당 대기 시간이 초과되었습니다.',
    });
  }, BOUND_BUTTON_ASSIGN_TIMEOUT_MS);

  boundButtonAssignCountdownId.value = setInterval(() => {
    if (!isBoundButtonAssignWaiting.value) return;
    const next = Math.max(0, boundButtonAssignRemainSec.value - 1);
    boundButtonAssignRemainSec.value = next;
    if (store.getters.visible) {
      store.commit('setDescription', boundButtonAssignWaitDescription(next));
    }
    if (next <= 0 && boundButtonAssignCountdownId.value) {
      clearInterval(boundButtonAssignCountdownId.value);
      boundButtonAssignCountdownId.value = null;
    }
  }, 1000);

  emitter.emit('showPopAlert', {
    title: '물리 버튼 할당',
    description: boundButtonAssignWaitDescription(totalSec),
    showCancel: true,
    showOk: false,
    cancelText: '취소',
    cancelCallback: () => {
      stopBoundButtonAssignWait();
    },
    closeCallback: () => {
      stopBoundButtonAssignWait();
    },
  });

  // 설정모드 진입 안내 — 가상버튼 설정 팝업은 닫음 (대기 로직은 유지)
  onCancelClick();
};

const onBoundButtonAssignClick = () => {
  if (isBoundButtonAssigned.value) {
    emitter.emit('showPopAlert', {
      description: '이미 물리 버튼이 할당되어 있습니다.\n먼저 해제한 뒤 새로 할당해주세요.',
    });
    return;
  }
  emitter.emit('showPopConfirm', {
    title: '물리 버튼 할당',
    description:
      '해당 포트에 기존 조명이 있으면 가상버튼 멤버로 옮깁니다.\n이미 다른 가상버튼에 할당된 포트는 사용할 수 없습니다.\n계속하시겠습니까?',
    okText: '계속',
    cancelText: '취소',
    okCallback: () => {
      startBoundButtonAssignWait();
    },
  });
};

const onBoundButtonClearClick = () => {
  emitter.emit('showPopConfirm', {
    title: '물리 버튼 해제',
    description:
      '할당된 물리 버튼을 해제하시겠습니까?\n흡수했던 조명·매핑이 있으면 물리 버튼으로 복구됩니다.',
    okText: '해제',
    cancelText: '취소',
    okCallback: async () => {
      try {
        const prevSerial = device.value?.boundButton?.controllerId;
        const result = await Axios.patch(`/devices/${device.value._id}/boundButton`, {
          boundButton: null,
        });
        if (result.resultCode === '0000') {
          store.commit('home/updateDeviceBoundButton', {
            deviceId: device.value._id,
            boundButton: undefined,
          });
          isBoundButtonInfoExpanded.value = false;
          try {
            await store.dispatch('home/fetchAllZones');
          } catch (e) {
            console.error('fetchAllZones after clear boundButton failed:', e);
          }
          const restore = result.resultData?.restore;
          const serial = restore?.controllerId || prevSerial;
          if (serial) {
            try {
              const maps = await buildButtonMapsForController(
                serial,
                store.getters['home/getZones'],
              );
              publishButtonMapsPayload(mqttControl, serial, maps);
            } catch (e) {
              console.error('button maps push after clear boundButton failed:', e);
            }
          }
          let description = '물리 버튼 할당이 해제되었습니다.';
          if (restore?.restored) {
            const prevPort = restore.port != null
              ? toDisplayLampPort(restore.port, serial)
              : null;
            description +=
              prevPort != null
                ? `\n${prevPort}번 물리 버튼을 복구하고 흡수 멤버를 정리했습니다.`
                : '\n이전 물리 버튼을 복구하고 흡수 멤버를 정리했습니다.';
          }
          emitter.emit('showPopAlert', { description });
        } else {
          emitter.emit('showPopAlert', {
            description: result.resultMessage || '해제에 실패했습니다.',
          });
        }
      } catch (e) {
        emitter.emit('showPopAlert', {
          description: '물리 버튼 해제에 실패했습니다.',
        });
      }
    },
  });
};

const onChangeNameClick = () => {
  menusButton.value.click();
  deviceItemModal.show();
}

const onDeleteClick = () => {
  menusButton.value.click();
  if (device.value?.isVirtual && device.value?.item?.onoff == 1) {
    emitter.emit('showPopAlert', {
      description: 'ON 상태의 가상버튼은 삭제할 수 없습니다.',
    });
    return;
  }

  const virtualDevices = devices.value?.filter(device => device.isVirtual);
  if (!device.value?.isVirtual && virtualDevices.length > 0) {
    emitter.emit('showPopAlert', {
      description: '가상버튼이 있으면 삭제할 수 없습니다.',
    });
    return;
  }

  const hasBoundPhysical =
    !!device.value?.isVirtual &&
    (!!device.value?.boundButtonAbsorb ||
      (device.value?.boundButton?.controllerId != null &&
        device.value?.boundButton?.port != null));

  emitter.emit('showPopConfirm', {
    title: '장치 삭제',
    description: hasBoundPhysical
      ? `${device.value.name} 장치를 삭제하시겠습니까?\n할당된 물리 버튼이 있으면 먼저 복구한 뒤 삭제합니다.`
      : `${device.value.name} 장치를 삭제하시겠습니까?`,
    okText: '삭제',
    cancelText: '취소',
    okCallback: () => {
      requestDeleteDevice(props.deviceId);
    },
  });
}

const onUpdateDeviceName = (value) => {
  if (value.length === 0) {
    emitter.emit('showPopAlert', {
      description: '장치 이름을 입력해주세요.',
    });
    return;
  }
  
  requestUpdateDevice({
    name: value,
  });
  deviceItemModal.hide();
}

const requestUpdateDevice = async (params) => {
  try {
    const result = await Axios.patch(
      DeviceApi.UPDATE_DEVICE.replace(':id', props.deviceId),
      params,
    );
    if (result.resultCode === '0000') {
      store.commit('home/updateDevice', {
        groupId: props.roomId,
        id: props.deviceId,
        data: params,
      });
    } else {
      emitter.emit('showPopAlert', {
        description: result.resultMessage,
      });
    }
  } catch (error) {
    emitter.emit('showPopAlert', {
      description: '장치 정보 수정에 실패했습니다.',
    });
  }
};

const requestDeleteDevice = async (deviceId) => {
  const restoreSerialHint =
    device.value?.boundButtonAbsorb?.controllerId ||
    device.value?.boundButton?.controllerId ||
    null;
  try {
    const result = await Axios.delete(
      DeviceApi.DELETE_DEVICE.replace(':id', deviceId),
    );
    if (result.resultCode === '0000') {
      onCancelClick();
      store.commit('home/deleteDevice', {
        zoneId: parseInt(zone.value._id),
        groupId: parseInt(props.roomId),
        deviceId,
      });
      const restore = result.resultData?.restore;
      try {
        await store.dispatch('home/fetchAllZones');
      } catch (e) {
        console.error('fetchAllZones after virtual delete failed:', e);
      }
      const serial = restore?.controllerId || restoreSerialHint;
      if (serial) {
        try {
          const maps = await buildButtonMapsForController(
            serial,
            store.getters['home/getZones'],
          );
          publishButtonMapsPayload(mqttControl, serial, maps);
        } catch (e) {
          console.error('button maps push after virtual delete failed:', e);
        }
      }
      if (restore?.restored) {
        const prevPort = restore.port != null
          ? toDisplayLampPort(restore.port, serial)
          : null;
        emitter.emit('showPopAlert', {
          description:
            prevPort != null
              ? `가상버튼을 삭제했고 ${prevPort}번 물리 버튼을 복구했습니다.`
              : '가상버튼을 삭제했고 할당된 물리 버튼을 복구했습니다.',
        });
      }
      return;
    }

    emitter.emit('showPopAlert', {
      description: result.resultMessage,
    });
  } catch (error) {
    console.log(error)
    emitter.emit('showPopAlert', {
      description: '장치 삭제 중 오류가 발생하였습니다.',
    });
  }
};
</script>

<style scoped>
.light-device-power-btn {
  width: 6rem;
  height: 6rem;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  transition: background 0.2s ease, box-shadow 0.2s ease, color 0.2s ease;
}

.light-device-power-btn i {
  font-size: 1.75rem;
  line-height: 1;
}

.light-device-power-btn--on {
  background: radial-gradient(
    circle at 50% 42%,
    var(--power-center) 0%,
    var(--power-mid) 48%,
    var(--power-edge) 100%
  );
  border: 2px solid var(--power-border, rgba(168, 173, 180, 0.52));
  box-shadow:
    0 0 0 1px var(--power-ring),
    0 6px 20px var(--power-glow),
    inset 0 2px 4px var(--power-inset, rgba(255, 255, 255, 0.75));
  color: #5c5348;
}

.light-device-power-btn--off {
  background: radial-gradient(circle at 50% 42%, #f8f9fa 0%, #eceff1 55%, #e2e6ea 100%);
  border: 2px solid #e5e7eb;
  box-shadow:
    inset 0 2px 5px rgba(0, 0, 0, 0.06),
    0 2px 6px rgba(0, 0, 0, 0.04);
  color: #adb5bd;
}

.light-device-sliders {
  width: 100%;
  max-width: 100%;
  margin-top: 0.15rem;
}

.light-device-slider-row {
  padding-top: 0.15rem;
  padding-bottom: 0.15rem;
  border: none;
}

.light-device-slider-row--bright {
  padding-bottom: 0.35rem;
}

.light-device-slider-row--temp {
  padding-top: 0.15rem;
  margin-top: 0.2rem;
  padding-bottom: 0.1rem;
}

.virtual-switch-info-root {
  border: 1px solid #e9ecef;
  border-radius: 0.9rem;
  background-color: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.virtual-switch-info-root.is-expanded .virtual-switch-info-header {
  border-bottom: 1px solid #e9ecef;
}

.virtual-switch-info-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.35rem;
  padding: 0.4rem 0.65rem;
  background-color: #f8f9fa;
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s ease;
}

.virtual-switch-info-header:hover {
  background-color: #eef1f4;
}

.virtual-switch-info-title {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.85rem;
  font-weight: 700;
  color: #212529;
  text-align: left;
}

.virtual-switch-info-icon {
  color: #0d6efd;
  font-size: 0.9rem;
}

.virtual-switch-info-chevron {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.65rem;
  height: 1.65rem;
  flex-shrink: 0;
  border-radius: 999px;
  background-color: #ffffff;
  border: 1px solid #e9ecef;
  color: #6c757d;
  transition: color 0.2s ease, border-color 0.2s ease;
}

.virtual-switch-info-header:hover .virtual-switch-info-chevron {
  color: #0d6efd;
  border-color: #cfe2ff;
}

.virtual-switch-info-body {
  padding: 0.3rem 0.65rem 0.4rem;
  background-color: #fafbfc;
}

.virtual-switch-detail-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.6rem;
  padding: 0.28rem 0;
  font-size: 0.78rem;
}

.virtual-switch-detail-row + .virtual-switch-detail-row {
  border-top: 1px solid #eef0f2;
}

.virtual-switch-detail-label {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  color: #6c757d;
  font-weight: 500;
  flex-shrink: 0;
}

.virtual-switch-detail-label i {
  color: #0d6efd;
  width: 1rem;
  text-align: center;
}

.virtual-switch-detail-value {
  font-weight: 600;
  color: #212529;
  text-align: right;
  word-break: break-all;
}

.virtual-switch-expand-enter-active,
.virtual-switch-expand-leave-active {
  transition: opacity 0.2s ease, max-height 0.25s ease;
  overflow: hidden;
}

.virtual-switch-expand-enter-from,
.virtual-switch-expand-leave-to {
  opacity: 0;
  max-height: 0;
}

.virtual-switch-expand-enter-to,
.virtual-switch-expand-leave-from {
  opacity: 1;
  max-height: 5.5rem;
}
</style>
